import styled from "@emotion/styled"

interface AgGridContainerProps {
  width?: string
}

export const AgGridContainer = styled.div<AgGridContainerProps>`
  height: 92px;
  width: ${props => `${props.width}px`};
  .ag-body-viewport.ag-layout-normal {
    overflow-y: hidden;
  }
`
